import * as graphql from 'generated/graphql';

export function countQuestions(
	questions: (graphql.FeedbackRequestQuestionInput & { id: string })[],
	goals: { goalID: string; text?: string }[],
	competencies: { competencyID: string; text?: string }[],
) {
	const filledQuestions = questions.filter((question) => question.text !== '');
	return goals.length + competencies.length + filledQuestions.length;
}

export function hasRequiredQuestions(
	questions: (graphql.FeedbackRequestQuestionInput & { id: string })[],
	goals: { goalID: string; text?: string }[],
	competencies: { competencyID: string; text?: string }[],
	minimumRequired: number,
) {
	const emptyQuestions = questions.filter((question) => question.text === '');

	const count = countQuestions(questions, goals, competencies);

	if (count < minimumRequired) {
		if (emptyQuestions.length > 0) {
			return 'emptyQuestions';
		}

		return 'notMeetingMinimum';
	}
	return undefined;
}
